/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ReportAlarmEntry { 
    date?: string | null;
    duration?: number | null;
    alarm?: string;
    alarm_id?: string;
}

